import { pt } from './pt';
import { en } from './en';

export const translations = { pt, en };

export const getTranslation = (language) => {
  return translations[language] || translations.pt;
};
